/**
 * 接口参考文档 
 * https://codeup.aliyun.com/62ecc679de1705ebb4f38538/wanfangche/api-v3/blob/master/docs/api_v1/h5pages.md
*/

import axios from './axios'

import json_default from './json/default.json'
import json_1001 from './json/1001.json'
import json_1002 from './json/1002.json'
import json_1003 from './json/1003.json'
import json_1004 from './json/1004.json'

const templateList = {
    "default": json_default, 
    "1001": json_1001,
    "1002": json_1002,
    "1003": json_1003,
    "1004": json_1004
}


 // 取第一张图作为封面
 function findPoster(form) {
    let url = null
    form.forEach(i => {
        if (Array.isArray(i.data)) {
            i.data.forEach(d => {
                if (d.url && !url) {
                    url = d.url
                }
            })
        }
    })
    return url
}

const api = {
    getTemplateById(id) {
        return new Promise((resolve,reject) => {
            const temp = templateList[id] ? templateList[id] : templateList['default']
            resolve(temp)
        })
    },
    fetchList (query) {
        if(!query.hasOwnProperty('status')) {
            query.status = 0
        }
        return axios.get('/api/v3/h5pages/', { params: query })
    },
    fetchOne (id) {
        return axios.get(`/api/v3/h5pages/${id}/`)
    },
    add (params={}) {
        return axios.post('/api/v3/h5pages/', params )
    },
    edit (id, params={}) {
        return axios.put(`/api/v3/h5pages/${id}/`, params)
    },
    // 移除到回收站
    trash(id) {
        return axios.patch(`/api/v3/h5pages/${id}/`,  { status: 1 } )
    },
    // 从回收站恢复
    untrash(id) {
        return axios.patch(`/api/v3/h5pages/${id}/`,  { status: 0 } )
    },
    delete(id) {
        return axios.delete(`/api/v3/h5pages/${id}/`)
    },
    publish(id) {
        return axios.put(`/api/v3/h5pages/${id}/uppublish/`, {params: { is_published: 1 }})
    },

    // 保存
    saveByForm(id, form=[] ) {
        if (!Array.isArray(form)) {
            return Promise.reject('系统错误,数据格式不正确')
        }
        const data = {
            name: form[0] && form[0].title ? form[0].title : '',
            describe: form[0] && form[0].remarks ? form[0].remarks : '',
            poster: form[0] && form[0].poster ? form[0].poster : findPoster(form), // 没有封面时，取第一章图作为封面
            json: JSON.stringify(form),
        }
        return api.edit(id, data)
    },

    // 通过表单添加
    addByForm(form=[], config={} ) {
        if (!Array.isArray(form)) {
            return Promise.reject('系统错误,数据格式不正确')
        }
        const data = {
            name: form[0] && form[0].title ? form[0].title : '',
            describe: form[0] && form[0].remarks ? form[0].remarks : '',
            poster: form[0] && form[0].poster ? form[0].poster : findPoster(form), // 没有封面时，取第一章图作为封面
            json: JSON.stringify(form),
            is_published: (typeof config.is_published == 'undefined') ? 0 : config.is_published, // 默认为非发布状态
            is_online: (typeof config.is_online == 'undefined') ? 1 : config.is_online,
        }
        return api.add(data)
    },
}

export default api